import { AuthHeading } from '../../Authentication/AuthControls';

type StepHeadingProps = { step: number; of: number; stepName: string; title: string; intro: string };

/**
 * The status row, heading and intro of a setup step. The label is the verified screen's
 * ("Email confirmed"), and the heading is the auth screens' own.
 */
export const StepHeading = ({ step, of, stepName, title, intro }: StepHeadingProps) => (
  <div className="flex flex-col items-start gap-3.5">
    <div className="flex flex-wrap items-center gap-2.5">
      <span className="micro-label text-ok border-ok-line bg-ok-bg flex-none rounded-full border px-3 py-1.5 whitespace-nowrap">
        Email confirmed
      </span>
      <span className="micro-label">
        Step {step} of {of} · {stepName}
      </span>
    </div>
    <AuthHeading title={title} subtitle={intro} />
  </div>
);
